import { createFileRoute } from '@tanstack/react-router';
import { RecentActivityPage } from '@pages/recent-activity';

export const Route = createFileRoute('/_authenticated/recent-activity')({
  staticData: { hideRail: true },
  component: RecentActivityPage,
});
